export default "__VITE_ASSET__ef3cb47a__"